var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RowEditFieldFile',{attrs:{"read-only":true,"field":_vm.field,"value":_vm.value,"workspace-id":_vm.workspaceId}})
}
var staticRenderFns = []

export { render, staticRenderFns }